<template>
  <v-container class="mb-4" style="max-width:100%; border-bottom: 3px solid rgba(0, 0, 0, 0.8)">
    <v-row v-if="!$vuetify.breakpoint.xs">
      <!-- imagen -->
      <v-col :cols="$vuetify.breakpoint.xs ? '12' : '6'">
        <v-img contain position="left" :src="require('@Base/assets/umivale_activa_hor_con_suma.svg')"
          :height="$vuetify.breakpoint.xs ? '60' : '70'" />
      </v-col>
      <v-col v-if="this.$router.currentRoute.name != '/' && solicitante" :cols="$vuetify.breakpoint.xs ? '12' : '6'"
        class="ma-0 pa-0">
        <DatosSolicitante :data="solicitante" />
      </v-col>
    </v-row>
    <!-- Titulo prestaciones -->
    <v-row class="mt-2 justify-center" style="background: #124D91;">
      <v-col
        :class="{ 'text-left col-9': $vuetify.breakpoint.smAndUp, 'col-12 text-center': !$vuetify.breakpoint.smAndUp }">
        <h1 style=" color: #FFFFFF !important" class="font-weight-bold"
          :class="{ 'headline': $vuetify.breakpoint.mdAndDown, 'display-1': $vuetify.breakpoint.lgAndUp }">
          {{ tituloModulo }}
        </h1>
      </v-col>
      <v-col class="pt-0 font"
        :class="{ 'text-left col-9': $vuetify.breakpoint.smAndUp, 'col-12 text-center': $vuetify.breakpoint.smAndDown }"
        style=" min-height: 30px; max-height: 30px;">
        <h3 style="color: #FFFFFF !important" class="font-weight-regular">
          {{ numeroReferencia }}
        </h3>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import DatosSolicitante from '@Base/pages/common/DatosSolicitante.vue'

export default {
  name: 'PageHeader',
  components: {
    DatosSolicitante
  },
  data() {
    return {
    }
  },
  computed: {
    /*serviceVersion() {
      return this.$store.state.solicitud.serviceVersion;
    },*/
    tituloModulo() {
      return this.$store.state.solicitud.tituloModulo;
    },
    pasoActual() {
      return this.$store.state.solicitud.pasoActual;
    },
    solicitante() {
      return this.$store.state.solicitud.solicitante;
    },
    numeroReferencia() {
      if (!this.solicitante) {
        return '';
      }
      return this.solicitante.numeroReferencia;
    },
  },
  /*watch: {
    // eslint-disable-next-line no-unused-vars
    serviceVersion(to, from) {
      if ((!!from && to != from) || (Build.UIVERSION !== to && window.ensureApplicationVersion === true)) {
        console.log("VERSION ACTUALIZADA:" + to);
        this.showUppdateAlert=true;
        var scrollRef = this;
        setTimeout(function() {
          scrollRef.$refs['updateAlert'].$el.scrollIntoView()
        }, 500);
      }
    }
  }*/
}
</script>